import React, { useRef } from "react";
import styled from "styled-components";
import css from "@styled-system/css";

import { Box, Text, Error, Warning, Input, Success } from "atoms";

import mergeRefs from "utils/mergeRefs";
import { theme } from "styles";

export const InputFieldBase = styled(Box)`
  position: relative;
  width: 100%;
  display: grid;
  align-items: center;
  font-size: 1.6rem;

  ${({ disabled, touched, fieldValue, type }) =>
    css({
      borderRadius: "1rem",
      fontFamily: "NeometricRegular",
      span: {
        position: "absolute",
        top: type === "textarea" ? "0%" : "50%",
        bg: "white",
        left: "22px",
        transform: "translateY(-50%)",
        transition: "0.2s all",
        color: "neutral.500",
        maxWidth: "calc(100% - 14px)",
      },

      ...{
        "& hint-text": {
          // display: "none",
          position: "absolute",
          left: "0%",
          fontSize: "1.3rem",
          fontWeight: "400",
          lineHeight: "2.4rem",
          mt: ".4rem",
          color: "neutral.600",
        },

        // "&:focus-within hint-text, &:active hint-text, &:focus hint-text": {
        //   display: "block",
        // },

        "& hint-text-success": {
          display: "none",
        },

        ...(touched &&
          !disabled && {
            "& hint-text-success": {
              display: "block",
              position: "absolute",
              left: "0%",
              fontSize: "1.4rem",
              fontWeight: "400",
              lineHeight: "2.4rem",
              mt: ".4rem",
              color: "accents.200",
            },
          }),

        // error classes

        "&.input-field-error span": {
          color: "accents.100",
        },

        "&.input-field-error input": {
          borderColor: "accents.100",
        },
        "&.input-field-error textarea": {
          borderColor: "accents.100",
        },

        "&.input-field-error input:focus, &.input-field-error input:active": {
          borderColor: "accents.100",
        },

        // success classes
        ...(fieldValue && {
          "&.input-field-success span": {
            color: "accents.200",
          },
        }),
        "&.input-field-success input": {
          borderColor: "accents.200",
        },
      },

      // ...(!labelHide && {
      //   "input, textarea": {
      //     "::placeholder": {
      //       opacity: 0,
      //       visibility: "hidden",
      //     },
      //     "&:focus": {
      //       borderColor: "neutral.400",
      //       "& + span": {
      //         color: "gray.900",
      //         px: "0.3rem",
      //       },
      //     },
      //     "&:focus + span, &:not(:placeholder-shown) + span": {
      //       top: "0px",
      //       fontSize: "1.2rem",
      //       px: "0.3rem",
      //       left: "16px",
      //     },
      //   },
      //   textarea: {
      //     "& + span": {
      //       top: "17px",
      //       transform: "none",
      //     },
      //     "&:focus + span, &:not(:placeholder-shown) + span": {
      //       top: "-7px",
      //       px: "0.3rem",
      //       left: "16px",
      //     },
      //   },
      // }),

      ...(disabled && {
        "input, textarea": {
          cursor: "not-allowed !important",
          // color: theme.colors.neutral[300],
          color: "#000",
          // borderColor: theme.colors.neutral[200],
          border: "none",
          background: "neutral.50",
          ":hover": {
            cursor: "not-allowed !important",
            borderColor: theme.colors.neutral[200],
          },
        },
      }),
    })}
`;

export const InputField = ({
  placeholder,
  error,
  warning,
  showLength,
  noMargin,
  forwardRef,
  touched,
  disabled,
  hintText,
  hintSuccessText,
  ...props
}) => {
  const ref = useRef | (null > null);

  const inputRef = mergeRefs(ref, forwardRef);
  return (
    <InputFieldBase
      // as={"label"}
      disabled={disabled}
      touched={touched}
      fieldValue={props?.value}
      type={props?.type}
      margin={noMargin ? "0 !important" : undefined}
      className={
        error
          ? "input-field-error"
          : touched && !disabled
          ? "input-field-success"
          : ""
      }
    >
      <Input
        placeholder={placeholder}
        ref={inputRef}
        touched={touched}
        status={error ? false : touched && !disabled ? true : null}
        disabled={disabled}
        {...props}
      />
      {/* {!labelHide && (
        <Text as="span" lineHeight="12px" ml="-0.2rem">
          {disabled ? "Disabled" : label}
        </Text>
      )} */}
      {/* </Text> */}
      {showLength && (
        <Text
          fontSize="1.2rem"
          position="absolute"
          bg="white"
          fontWeight="300"
          color="neutral.700"
          right="0.7rem"
          bottom="1rem"
          css={{ pointerEvents: "none" }}
        >
          {inputRef?.current?.value?.length || 0} / {props.maxLength}
        </Text>
      )}
      {error && (
        <Box css={{ pointerEvents: "none" }}>
          <Error text={error} />
        </Box>
      )}
      {/* {hintText && (
        <Box css={{ pointerEvents: "none" }} >
          <Box as={"hint-text"}>{hintText}</Box>
        </Box>
      )} */}
      {!error && touched && !disabled && hintSuccessText && (
        <Box css={{ pointerEvents: "none" }}>
          <Success>{hintSuccessText}</Success>
        </Box>
      )}
      {warning && <Warning text={warning} />}
    </InputFieldBase>
  );
};
